import market from './market'

function install (Vue, options) {
    Vue.prototype.$market = market
}
export default {
    install
}